import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {displayEndToModel, displayStartToModel, modelEndToDisplay, modelStartToDisplay} from 'molbio/SeqUtil';
import TextInput from 'ui-library/inputs/TextInput';

export interface IndexSelectionGroupProps {
  updateEndIndex: (endIndex: number | null) => void;
  updateStartIndex: (startIndex: number | null) => void;
  disabled: boolean;
  endIndex: number | null;
  endPlaceholder?: string;
  sequenceLength: number;
  sequenceStartIndex: number;
  startIndex: number | null;
  startPlaceholder?: string;
}

export default function IndexSelectionGroup({
  updateEndIndex,
  updateStartIndex,
  disabled,
  endIndex,
  endPlaceholder,
  sequenceLength,
  sequenceStartIndex,
  startIndex,
  startPlaceholder,
}: IndexSelectionGroupProps): JSX.Element {
  return (
    <div className={css(styles.positionFields)}>
      <TextInput
        placeholder={startPlaceholder || 'Start'}
        className={css(styles.positionInput)}
        value={modelStartToDisplay(startIndex, sequenceStartIndex) ?? ''}
        onChange={(e) => {
          updateStartIndex(
            Number.isNaN(parseInt(e.target.value, 10))
              ? null
              : displayStartToModel(parseInt(e.target.value, 10), sequenceStartIndex)
          );
        }}
        disabled={disabled}
        dataTestAttrs={{component: 'IndexSelectionGroup', element: 'startInput'}}
      />
      <h3 className={css(styles.positionDash)}>-</h3>
      <TextInput
        className={css(styles.positionInput)}
        placeholder={endPlaceholder || 'End'}
        value={modelEndToDisplay(endIndex, sequenceLength, sequenceStartIndex) ?? ''}
        onChange={(e) => {
          updateEndIndex(
            Number.isNaN(parseInt(e.target.value, 10))
              ? null
              : displayEndToModel(parseInt(e.target.value, 10), sequenceLength, sequenceStartIndex)
          );
        }}
        disabled={disabled}
        dataTestAttrs={{component: 'IndexSelectionGroup', element: 'endInput'}}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  positionDash: {
    margin: 'auto 12px',
  },
  positionFields: {
    display: 'flex',
  },
  positionInput: {
    width: '72px',
  },
});
